"use client";
import React from "react";
import Block from "./webflow_modules/Basic/components/Block";
import Image from "./webflow_modules/Basic/components/Image";
import Link from "./webflow_modules/Basic/components/Link";
import Section from "./webflow_modules/Layout/components/Section";
import * as _interactions from "./webflow_modules/interactions";

const _interactionsData = JSON.parse(
  '{"events":{"e-45":{"id":"e-45","name":"","animationType":"custom","eventTypeId":"MOUSE_OVER","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-17","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-46"}},"mediaQueries":["main","medium","small","tiny"],"target":{"selector":".gallery_overlay-trigger","originalId":"f2687902-42de-0ebd-427b-fa1ba1e6693f","appliesTo":"CLASS"},"targets":[{"selector":".gallery_overlay-trigger","originalId":"f2687902-42de-0ebd-427b-fa1ba1e6693f","appliesTo":"CLASS"}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":null,"scrollOffsetUnit":null,"delay":null,"direction":null,"effectIn":null},"createdOn":1702675855485},"e-46":{"id":"e-46","name":"","animationType":"custom","eventTypeId":"MOUSE_OUT","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-18","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-45"}},"mediaQueries":["main","medium","small","tiny"],"target":{"selector":".gallery_overlay-trigger","originalId":"f2687902-42de-0ebd-427b-fa1ba1e6693f","appliesTo":"CLASS"},"targets":[{"selector":".gallery_overlay-trigger","originalId":"f2687902-42de-0ebd-427b-fa1ba1e6693f","appliesTo":"CLASS"}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":null,"scrollOffsetUnit":null,"delay":null,"direction":null,"effectIn":null},"createdOn":1702675855485}},"actionLists":{"a-17":{"id":"a-17","title":"Gallery Overlay [show]","actionItemGroups":[{"actionItems":[{"id":"a-17-n","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"useEventTarget":"CHILDREN","selector":".gallery_overlay","selectorGuids":["040e546d-12f8-255d-b6ec-896d5158c108"]},"value":"none"}},{"id":"a-17-n-3","actionTypeId":"STYLE_OPACITY","config":{"delay":0,"easing":"","duration":500,"target":{"useEventTarget":"CHILDREN","selector":".gallery_overlay","selectorGuids":["040e546d-12f8-255d-b6ec-896d5158c108"]},"value":0,"unit":""}}]},{"actionItems":[{"id":"a-17-n-2","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"useEventTarget":"CHILDREN","selector":".gallery_overlay","selectorGuids":["040e546d-12f8-255d-b6ec-896d5158c108"]},"value":"flex"}},{"id":"a-17-n-4","actionTypeId":"STYLE_OPACITY","config":{"delay":0,"easing":"ease","duration":200,"target":{"useEventTarget":"CHILDREN","selector":".gallery_overlay","selectorGuids":["040e546d-12f8-255d-b6ec-896d5158c108"]},"value":1,"unit":""}}]}],"useFirstGroupAsInitialState":true,"createdOn":1702675650763},"a-18":{"id":"a-18","title":"Gallery Overlay [hide]","actionItemGroups":[{"actionItems":[{"id":"a-18-n-2","actionTypeId":"STYLE_OPACITY","config":{"delay":0,"easing":"ease","duration":200,"target":{"useEventTarget":"CHILDREN","selector":".gallery_overlay","selectorGuids":["040e546d-12f8-255d-b6ec-896d5158c108"]},"value":0,"unit":""}}]},{"actionItems":[{"id":"a-18-n","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"ease","duration":0,"target":{"useEventTarget":"CHILDREN","selector":".gallery_overlay","selectorGuids":["040e546d-12f8-255d-b6ec-896d5158c108"]},"value":"none"}}]}],"useFirstGroupAsInitialState":false,"createdOn":1702675650763}},"site":{"mediaQueries":[{"key":"main","min":992,"max":10000},{"key":"medium","min":768,"max":991},{"key":"small","min":480,"max":767},{"key":"tiny","min":0,"max":479}]}}'
);

export function Gallery({}) {
  _interactions.useInteractions(_interactionsData);

  return (
    <Section className={"gallery"} tag={"section"}>
      <Block className={"gallery_grid"} tag={"div"}>
        <Block className={"image-3x2"} tag={"div"}>
          <Image
            alt={""}
            className={"gallery_image"}
            height={"auto"}
            id={"w-node-f2687902-42de-0ebd-427b-fa1ba1e6693e-a1e6693b"}
            loading={"lazy"}
            src={
              "https://cdn.prod.website-files.com/656bce4e0dae8369c9788229/69654ae2035cd9341357fb4d_Alwell%20-%20Pleasant%20Hill%2C%20CA.jpeg"
            }
            width={"auto"}
          />
          <Link
            aria-label={"This is not a link at this time."}
            block={"inline"}
            button={false}
            className={"gallery_overlay-trigger"}
            options={{
              href: "#",
            }}
          >
            <Block className={"gallery_overlay"} tag={"div"}>
              <Block tag={"div"}>
                <Block className={"margin-bottom margin-xsmall"} tag={"div"}>
                  <Block className={"text-size-large"} tag={"div"}>
                    {"Alwell"}
                  </Block>
                </Block>
                <Block tag={"div"}>{"Pleasant Hill, CA"}</Block>
              </Block>
            </Block>
          </Link>
        </Block>
        <Block
          className={"image-1x2"}
          id={"w-node-f2687902-42de-0ebd-427b-fa1ba1e66947-a1e6693b"}
          tag={"div"}
        >
          <Image
            alt={""}
            className={"gallery_image"}
            height={"auto"}
            id={"w-node-f2687902-42de-0ebd-427b-fa1ba1e66948-a1e6693b"}
            loading={"lazy"}
            src={
              "https://cdn.prod.website-files.com/656bce4e0dae8369c9788229/6a878a9425d35c4352aa0166_domain-weho1.jpg"
            }
            width={"auto"}
          />
          <Link
            aria-label={"This is not a link at this time"}
            block={"inline"}
            button={false}
            className={"gallery_overlay-trigger"}
            options={{
              href: "#",
            }}
          >
            <Block className={"gallery_overlay"} tag={"div"}>
              <Block tag={"div"}>
                <Block className={"margin-bottom margin-xsmall"} tag={"div"}>
                  <Block className={"text-size-large"} tag={"div"}>
                    {"Haven"}
                  </Block>
                </Block>
                <Block tag={"div"}>{"Culver City, CA"}</Block>
              </Block>
            </Block>
          </Link>
        </Block>
        <Block
          className={"image-3x2"}
          id={"w-node-f2687902-42de-0ebd-427b-fa1ba1e66951-a1e6693b"}
          tag={"div"}
        >
          <Image
            alt={""}
            className={"gallery_image"}
            height={"auto"}
            id={"w-node-f2687902-42de-0ebd-427b-fa1ba1e66952-a1e6693b"}
            loading={"lazy"}
            src={
              "https://cdn.prod.website-files.com/656bce4e0dae8369c9788229/69654b38fbd9d2bdc4b432c6_NoMa%20(Walnut%20Creek%2C%20CA).jpeg"
            }
            width={"auto"}
          />
          <Link
            aria-label={"Thi is not a link at this time"}
            block={"inline"}
            button={false}
            className={"gallery_overlay-trigger"}
            options={{
              href: "#",
            }}
          >
            <Block className={"gallery_overlay"} tag={"div"}>
              <Block tag={"div"}>
                <Block className={"margin-bottom margin-xsmall"} tag={"div"}>
                  <Block className={"text-size-large"} tag={"div"}>
                    {"NoMa"}
                  </Block>
                </Block>
                <Block tag={"div"}>{"Walnut Creek, CA"}</Block>
              </Block>
            </Block>
          </Link>
        </Block>
        <Block
          className={"image-2x1"}
          id={"w-node-f2687902-42de-0ebd-427b-fa1ba1e6695b-a1e6693b"}
          tag={"div"}
        >
          <Image
            alt={""}
            className={"gallery_image"}
            height={"auto"}
            id={"w-node-f2687902-42de-0ebd-427b-fa1ba1e6695c-a1e6693b"}
            loading={"lazy"}
            src={
              "https://cdn.prod.website-files.com/656bce4e0dae8369c9788229/65dcb939441387dfa8413294_5-Palomino.jpeg"
            }
            width={"auto"}
          />
          <Link
            aria-label={"This is no a link at this time."}
            block={"inline"}
            button={false}
            className={"gallery_overlay-trigger"}
            options={{
              href: "#",
            }}
          >
            <Block className={"gallery_overlay"} tag={"div"}>
              <Block tag={"div"}>
                <Block className={"margin-bottom margin-xsmall"} tag={"div"}>
                  <Block className={"text-size-large"} tag={"div"}>
                    {"Palomino"}
                  </Block>
                </Block>
                <Block tag={"div"}>{"Reno, NV"}</Block>
              </Block>
            </Block>
          </Link>
        </Block>
      </Block>
      <Block className={"gallery_grid"} tag={"div"}>
        <Block
          className={"image-2x1"}
          id={"w-node-f2687902-42de-0ebd-427b-fa1ba1e66966-a1e6693b"}
          tag={"div"}
        >
          <Image
            alt={""}
            className={"gallery_image"}
            height={"auto"}
            id={"w-node-f2687902-42de-0ebd-427b-fa1ba1e66967-a1e6693b"}
            loading={"lazy"}
            src={
              "https://cdn.prod.website-files.com/656bce4e0dae8369c9788229/65dcb939f00b356f854d27e4_7-royce.jpeg"
            }
            width={"auto"}
          />
          <Link
            aria-label={"This is not a link at this time"}
            block={"inline"}
            button={false}
            className={"gallery_overlay-trigger"}
            options={{
              href: "#",
            }}
          >
            <Block className={"gallery_overlay"} tag={"div"}>
              <Block tag={"div"}>
                <Block className={"margin-bottom margin-xsmall"} tag={"div"}>
                  <Block className={"text-size-large"} tag={"div"}>
                    {"Promenade Rio Vista"}
                  </Block>
                </Block>
                <Block tag={"div"}>{"San Diego, CA"}</Block>
              </Block>
            </Block>
          </Link>
        </Block>
        <Block
          className={"image-1x2"}
          id={"w-node-f2687902-42de-0ebd-427b-fa1ba1e66970-a1e6693b"}
          tag={"div"}
        >
          <Image
            alt={""}
            className={"gallery_image"}
            height={"auto"}
            id={"w-node-f2687902-42de-0ebd-427b-fa1ba1e66971-a1e6693b"}
            loading={"lazy"}
            src={
              "https://cdn.prod.website-files.com/656bce4e0dae8369c9788229/6a1a13aaafcaad6fe3ca6dc1_casita-photo.jpg"
            }
            width={"auto"}
          />
          <Link
            aria-label={"This is not a link at this time."}
            block={"inline"}
            button={false}
            className={"gallery_overlay-trigger"}
            options={{
              href: "#",
            }}
          >
            <Block className={"gallery_overlay"} tag={"div"}>
              <Block tag={"div"}>
                <Block className={"margin-bottom margin-xsmall"} tag={"div"}>
                  <Block className={"text-size-large"} tag={"div"}>
                    {"Casata Austin"}
                  </Block>
                </Block>
                <Block tag={"div"}>{"Austin, TX"}</Block>
              </Block>
            </Block>
          </Link>
        </Block>
        <Block
          className={"image-3x2"}
          id={"w-node-f2687902-42de-0ebd-427b-fa1ba1e6697a-a1e6693b"}
          tag={"div"}
        >
          <Image
            alt={""}
            className={"gallery_image"}
            height={"auto"}
            id={"w-node-f2687902-42de-0ebd-427b-fa1ba1e6697b-a1e6693b"}
            loading={"lazy"}
            src={
              "https://cdn.prod.website-files.com/656bce4e0dae8369c9788229/6762f690a41f9bb5fb6b77f4_CapitolYards_11182015_072.jpg"
            }
            width={"auto"}
          />
          <Link
            aria-label={"This is not a link at this time"}
            block={"inline"}
            button={false}
            className={"gallery_overlay-trigger"}
            options={{
              href: "#",
            }}
          >
            <Block className={"gallery_overlay"} tag={"div"}>
              <Block tag={"div"}>
                <Block className={"margin-bottom margin-xsmall"} tag={"div"}>
                  <Block className={"text-size-large"} tag={"div"}>
                    {"Capitol Yards"}
                  </Block>
                </Block>
                <Block tag={"div"}>{"West Sacramento, CA"}</Block>
              </Block>
            </Block>
          </Link>
        </Block>
        <Block
          className={"image-3x2"}
          id={"w-node-f2687902-42de-0ebd-427b-fa1ba1e66984-a1e6693b"}
          tag={"div"}
        >
          <Image
            alt={""}
            className={"gallery_image"}
            height={"auto"}
            id={"w-node-f2687902-42de-0ebd-427b-fa1ba1e66985-a1e6693b"}
            loading={"lazy"}
            src={
              "https://cdn.prod.website-files.com/656bce4e0dae8369c9788229/69654b8ad7d141ae310eeda2_Classen%2016%20(Oklahoma%20City%2C%20OK.jpeg"
            }
            width={"auto"}
          />
          <Link
            aria-label={"This is not a link at this time"}
            block={"inline"}
            button={false}
            className={"gallery_overlay-trigger"}
            options={{
              href: "#",
            }}
          >
            <Block className={"gallery_overlay"} tag={"div"}>
              <Block tag={"div"}>
                <Block className={"margin-bottom margin-xsmall"} tag={"div"}>
                  <Block className={"text-size-large"} tag={"div"}>
                    {"Bloom"}
                  </Block>
                </Block>
                <Block tag={"div"}>{"Oklahoma City, OK"}</Block>
              </Block>
            </Block>
          </Link>
        </Block>
      </Block>
    </Section>
  );
}
